<template>
  <div class="urgeRent">
    <el-tabs v-model="activeName">
      <el-tab-pane
        label="预提醒明细表"
        name="remind"
        v-if="judgePermission('under_lease_over_due_hasten_debt_remind_list')"
      >
        <div v-if="activeName == 'remind'">
          <remind-detail-list />
        </div>
      </el-tab-pane>
      <el-tab-pane
        label="逾期明细表"
        v-if="judgePermission('under_lease_over_due_hasten_debt_list')"
        name="overdue"
      >
        <div v-if="activeName == 'overdue'">
          <overdue-detail-list />
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
// 组件
import overdueDetailList from '../components/overdueDetailList.vue'
import remindDetailList from '../components/remindDetailList.vue'

export default {
  components: {
    overdueDetailList,
    remindDetailList,
  },
  data() {
    return {
      activeName: 'remind',
    }
  },
  created() {
    const { tabType } = this.$route.query
    this.activeName = tabType || 'remind'
  },
}
</script>
<style scoped lang="scss">
.cars-manage,
.el-tabs {
  width: 100%;
  height: 100%;
}
</style>
